// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_i-1";
export var movingGradient = "_i-4";
export var movingGradientBlock = "_i-2";
export var skeleton = "_i-0";
export var skeletonText = "_i-3";